import { Accordion, Group, Stack, Text } from "@mantine/core";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import { useConfigStore } from "../../../../../../stores/ConfigStore";

function getFieldLabel(field_name) {
  return field_name;
}

const ArgumentsContactsSelection = ({ contactsSelection }) => {
  const lang = useLanguage((s) => s.language);
  const datafields = useConfigStore((s) => s.datafields);

  const getFilterItem = (item) => {
    if (item?.values?.length > 0) {
      return (
        <Stack
          p={"sm"}
          gap={4}
          pl={8}
          style={{ border: "1px solid #00000012", borderRadius: 8 }}
        >
          <Text ml={8}>
            <b>{lang.table.toolbar.filter.conditions[item.mode]}</b>{" "}
          </Text>
          <Stack
            style={{ borderLeft: "1px solid #00000012" }}
            pl={16}
            ml={16}
            gap={4}
          >
            {item.values.map((filterItem, i) => {
              if (filterItem?.values) {
                return filterItem?.values.map((v) => getFilterItem(v));
              }
              return getFilterItem(filterItem);
            })}
          </Stack>
        </Stack>
      );
    }
    let field_id = parseInt(item.field_name);
    let fieldLabel = field_id
      ? datafields.find((x) => x.id === field_id)?.name || ""
      : getFieldLabel(item.field_name);
    let fieldCondition =
      lang.table.toolbar.filter.filters_list_label.server?.[item?.type] ||
      item?.type;
    let value = item.value;
    return (
      <Group gap={"xl"} style={{ borderBottom: "1px solid #00000012" }} pb={6}>
        <Text fw={500} w={200}>
          {fieldLabel || item?.field_name}
        </Text>
        <Text w={200}> {fieldCondition} </Text>
        <Text fw={500}> {value} </Text>
      </Group>
    );
  };

  if (contactsSelection && contactsSelection?.filter?.values?.length > 0)
    return (
      <Accordion variant="contained">
        <Accordion.Item value="filter">
          <Accordion.Control>
            {lang.table.toolbar.filter.main_button_label}
          </Accordion.Control>
          <Accordion.Panel>
            {getFilterItem(contactsSelection.filter)}
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    );
};

export default ArgumentsContactsSelection;
